module.exports = __webpack_public_path__ + "static/media/utensils-alt.535a20ef.svg";